import { useQuery } from '@tanstack/react-query'

import {
  getShopEventId,
  getTicketDetailByEventTicketId,
  getTicketTypeList,
} from '~/features/ticket/apis/ticket'

const TICKET_KEYS = {
  base: [{ scope: 'ticket' }] as const,
  shopEventId: () =>
    [{ ...TICKET_KEYS.base[0], entity: 'shopEventId' }] as const,
  ticketTypeList: (eventId?: number) =>
    [{ ...TICKET_KEYS.base[0], entity: 'ticketTypeList', eventId }] as const,
  ticketDetail: (eventTicketId: number) =>
    [
      { ...TICKET_KEYS.base[0], entity: 'ticketDetail', eventTicketId },
    ] as const,
}

export const useShopEventId = () => {
  return useQuery({
    queryKey: TICKET_KEYS.shopEventId(),
    queryFn: () => getShopEventId(),
  })
}

export const useTicketTypeList = (eventId: number) => {
  return useQuery({
    queryKey: TICKET_KEYS.ticketTypeList(eventId),
    queryFn: () => getTicketTypeList(eventId),
    enabled: !!eventId,
  })
}

export const useTicketDetail = (eventTicketId: number) => {
  return useQuery({
    queryKey: TICKET_KEYS.ticketDetail(eventTicketId),
    queryFn: () => getTicketDetailByEventTicketId(eventTicketId),
  })
}
